import { SHOW_PRODUCTS } from '../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
};
